@let labelValue = label();

@switch (state()) {
  @case ('not_started') {
    <span>⏳ Starting ...</span>
  }
  @case ('in_progress') {
    <span>⌛ In progress ...</span>
  }
  @case ('success') {
    <span class="passed">✅ Passed</span>
    @if (labelValue) {
      : {{ labelValue }}
    }
  }
  @case ('failed') {
    <span class="passed">❌ Failed</span>
    @if (labelValue) {
      : {{ labelValue }}
    }
  }
}
